import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(
    private readonly http: HttpClient
  ) { }

  async get(auth: any, url: string, headers: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if(headers == null) headers = {};
      if(auth != null) {
        let keys = Object.keys(auth);
        if(keys.length > 0) {
          let th = keys[0]
          headers[th] = auth[th];
        }
      }
      
      this.http.get<any>(url,{headers})
      .subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

  async post(auth: any, url: string, headers: any, body: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if(headers == null) headers = {};
      if(auth != null) {
        let keys = Object.keys(auth);
        if(keys.length > 0) {
          let th = keys[0]
          headers[th] = auth[th];
        }
      }
      
      this.http.post<any>(url, body, {headers})
      .subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

  async patch(auth: any, url: string, headers: any, body: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if(headers == null) headers = {};
      if(auth != null) {
        let keys = Object.keys(auth);
        if(keys.length > 0) {
          let th = keys[0]
          headers[th] = auth[th];
        }
      }
      
      this.http.patch<any>(url, body, {headers})
      .subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

  async delete(auth: any, url: string, headers: any, body: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if(headers == null) headers = {};
      if(auth != null) {
        let keys = Object.keys(auth);
        if(keys.length > 0) {
          let th = keys[0]
          headers[th] = auth[th];
        }
      }
      
      this.http.delete<any>(url, {headers, body})
      .subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }
}
